import React, { useEffect } from "react";
import mpesa from "../../assets/svg/mpesa.jpeg";
import svg48 from "../../assets/svg/svg48.svg";
import paypal from "../../assets/svg/paypal.png";
import bitcoin from "../../assets/svg/bitcoin-btc-logo.png";

import { Divider, Table, Tag } from "antd"; 
import { useDispatch, useSelector } from "react-redux";
import { cashConverter, numberWithCommas } from "../../utils";

const prodItems = [
  {
    id: "MPESA",
    title: "M-Pesa",
    image: mpesa,
  },
  {
    id: "BANK",
    title: "Bank",
    image: svg48,
  },
  {
    id: "PAYPAL",
    title: "PAYPAL",
    image: paypal,
  },
  {
    id: "BITCOIN",
    title: "Cryptocurrency",
    image: bitcoin,
  },
];

function PayoutMethod() {
  const dispatch = useDispatch();
  const { loading, tariffData } = useSelector((state) => state.auth);
  const { tariffs } = useSelector((state) => state.dropdown);
  
  const newTariff =
    tariffs &&
    tariffs
      ?.filter((item) => item?.tarType === "MPESA")
      ?.sort((a, b) => a?.tarFrom - b?.tarFrom);

      const dataSource = [
        {
          key: '1',
          name: 'Mike',
          age: 32,
          address: '10 Downing Street',
        },
        {
          key: '2',
          name: 'John',
          age: 42,
          address: '10 Downing Street',
        },
      ];
  const columns = [
    {
      title: "From",
      render: (item) => {
        return <div>{numberWithCommas(item)}</div>;
      },
      dataIndex: "tarFrom",
    },
    {
      title: "To",
      render: (item) => {
        return <div>{numberWithCommas(item)}</div>;
      },
      dataIndex: "tarTo",
    },
    {
      title: "Type",
      render: (item) => {
        return <div>{item === "MPESA" ? "B2C" : null}</div>;
      },
      dataIndex: "tarType",
    },
    {
      title: "Charges",
      dataIndex: "tarCharges",
    },
  ];
 
  return (
    <div className="report-card px-3 p-2 h-auto w-full">
      <div className="product_sub !text-[18px]">Payout Tariff</div>
      <Table
        dataSource={newTariff}
        columns={columns}
        className="mt-[1.31rem] w-full"
        scroll={{
          x: 800,
        }}
        pagination={{
          position: ["bottomCenter"],
          pageSize: 5,
        }}
        loading={loading}
        rowKey={(record) => record?.tarId}
      />
      
    </div>
  );
}

export default PayoutMethod;
